<div class="w-full text-left border-collapse min-w-[1000px] md:min-w-full">
  <h1 class="text-2xl font-bold text-gray-900 mb-8">Property Values</h1>

  <!-- ALL GENERIC DROPDOWNS -->
  <!-- <div class="grid md:grid-cols-2 gap-4">
    <div *ngFor="let key of dropdownKeys"
        class="bg-white border border-gray-200 rounded-2xl p-6
                shadow-sm hover:shadow-md transition">

        <div class="flex items-center justify-between mb-4">
        <h3 class="text-lg font-semibold text-gray-900">
            {{ labels[key] }}
        </h3>
        <span class="text-xs text-gray-500 bg-gray-100 px-3 py-1 rounded-full">
            {{ dropdowns[key].length }} values
        </span>
        </div>

        <div class="flex gap-3 mb-5">
        <input
            [(ngModel)]="newValues[key]"
            placeholder="Add new value"
            class="flex-1 px-4 py-2.5 rounded-xl
                border border-gray-300
                focus:ring-2 focus:ring-black/10
                focus:border-black transition"
        />
        <button
            (click)="addValue(key)"
            class="px-5 py-2.5 rounded-xl bg-black text-white
                text-sm font-semibold hover:bg-gray-900
                active:scale-95 transition">
            Add
        </button>
        </div>

        <div class="flex flex-wrap gap-2">
        <div *ngFor="let option of dropdowns[key]; let i = index"
            class="flex gap-2 items-center justify-between
                    p-2 rounded-xl
                    bg-gray-50 border border-gray-200">

            <span class="text-sm font-medium text-gray-800">
            {{ option }}
            </span>

            <button
            (click)="removeValue(key, i)"
            class="text-gray-400 hover:text-red-500 transition">
            ✕
            </button>
        </div>
        </div>

    </div>
  </div> -->

  <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
    <div class="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm">
      <form [formGroup]="clusterForm">
        <div class="flex items-center justify-between mb-4">
          <h3 class="text-lg font-semibold">Clusters</h3>

          <span class="text-xs bg-gray-100 px-3 py-1 rounded-full">
            {{ clusters.length }} values
          </span>
        </div>

        <div class="flex gap-3 mb-5">
          <input
            formControlName="newCluster"
            placeholder="Cluster name"
            class="flex-1 px-4 py-2.5 rounded-xl border border-gray-300"
          />

          <button
            type="button"
            (click)="addCluster()"
            class="px-5 py-2.5 rounded-xl bg-black text-white"
          >
            + Add
          </button>
        </div>

        <!-- Added Clusters -->
        <div formArrayName="clusters" class="space-y-2 mb-5">
          <div
            *ngFor="let cluster of clusters.controls; let i = index"
            [formGroupName]="i"
            class="flex items-center justify-between px-4 py-3 rounded-xl border border-gray-200 bg-gray-50"
          >
            <span class="font-medium">
              {{ cluster.get("cluster")?.value }}
            </span>

            <button
              type="button"
              (click)="removeCluster(i)"
              class="text-red-500 hover:text-red-700"
            >
              ✕
            </button>
          </div>
        </div>

        <button
          type="button"
          (click)="submitClusters()"
          class="px-4 py-3 rounded-xl bg-[#111827] text-white font-medium"
        >
          Submit Clusters
        </button>
      </form>
    </div>

    <div class="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm">
      <form [formGroup]="microMarketForm">
        <div class="flex items-center justify-between mb-4">
          <h3 class="text-lg font-semibold">Micro Markets</h3>

          <span class="text-xs bg-gray-100 px-3 py-1 rounded-full">
            {{ microMarkets.length }} values
          </span>
        </div>

        <div class="grid grid-cols-2 gap-3 mb-4">
          <input
            formControlName="micromarketName"
            placeholder="Micro Market"
            class="px-4 py-2.5 rounded-xl border border-gray-300"
          />

          <select
            formControlName="cluster"
            class="px-4 py-2.5 rounded-xl border border-gray-300"
          >
            <option value="">Select Cluster</option>

            <option *ngFor="let item of cluster" [value]="item.cluster">
              {{ item.cluster }}
            </option>
          </select>
        </div>

        <button
          type="button"
          (click)="addMicroMarket()"
          class="mb-5 px-5 py-2.5 rounded-xl bg-black text-white"
        >
          + Add
        </button>

        <!-- Added Markets -->
        <div formArrayName="microMarkets" class="space-y-2 mb-5">
          <div
            *ngFor="let market of microMarkets.controls; let i = index"
            [formGroupName]="i"
            class="flex items-center justify-between px-4 py-3 rounded-xl border border-gray-200 bg-gray-50"
          >
            <div>
              <p class="font-medium">
                {{ market.get("micromarketName")?.value }}
              </p>

              <p class="text-xs text-gray-500">
                Cluster: {{ market.get("cluster")?.value }}
              </p>
            </div>

            <button
              type="button"
              (click)="removeMicroMarket(i)"
              class="text-red-500 hover:text-red-700"
            >
              ✕
            </button>
          </div>
        </div>

        <button
          type="button"
          (click)="submitMicroMarkets()"
          class="py-3 px-4 rounded-xl bg-[#111827] text-white font-medium"
        >
          Submit Micro Markets
        </button>
      </form>
    </div>
  </div>

  <div class="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-10">
   
    <div class="bg-white border border-gray-200 rounded-xl overflow-hidden">

      <!-- Header -->
      <div class="flex items-center justify-between px-4 py-3 border-b border-gray-100">
        <div class="flex items-center gap-2">
          <i class="ti ti-building-community text-gray-400 text-base"></i>
          <span class="text-sm font-medium text-gray-800">Cluster zones</span>
        </div>
        <span class="text-xs text-gray-500 bg-gray-50 border border-gray-200 px-3 py-1 rounded-full">
          {{ filteredCluster.length }} clusters
        </span>
      </div>
    
      <!-- Search -->
      <div class="flex items-center gap-2 px-4 py-2.5 border-b border-gray-100">
        <i class="ti ti-search text-gray-300 text-sm"></i>
        <input
          type="text"
          [(ngModel)]="searchQueryCluster"
          placeholder="Search cluster or cluster…"
          class="flex-1 text-sm bg-transparent outline-none text-gray-800 placeholder-gray-300"
        />
      </div>
    
      <!-- Virtual Scroll List -->
      <cdk-virtual-scroll-viewport itemSize="57" class="h-[400px]">
        <ul>
          <li
            *cdkVirtualFor="let item of filteredCluster; let i = index"
            class="flex items-center gap-3 px-4 py-3 cursor-default
                   hover:bg-gray-50 transition-colors duration-150
                   border-b border-gray-100 last:border-b-0
                   animate-[rowIn_0.32s_ease-out_both]"
            [style.animation-delay]="i * 55 + 'ms'"
          >
            <!-- Index badge -->
            <div class="min-w-[26px] h-[26px] rounded-full bg-green-50 flex items-center
                        justify-center text-[11px] font-medium text-green-600
                        animate-[badgePop_0.4s_cubic-bezier(.34,1.56,.64,1)_both]"
                 [style.animation-delay]="i * 55 + 70 + 'ms'">
              {{ i + 1 }}
            </div>
    
            <!-- Name + cluster -->
            <div class="flex-1 min-w-0">
              <p class="text-sm font-medium text-gray-800 truncate">{{ item.cluster }}</p>
              <div class="flex items-center gap-1 mt-0.5">
                <i class="ti ti-map-pin text-gray-300 text-[11px]"></i>
                <span class="text-xs text-gray-400">Added {{ item.createdAt | date : "dd MMM yyyy" }}</span>
              </div>
            </div>
    
            <!-- ID chip -->
            <span class="text-[11px] text-gray-400 font-mono bg-gray-50 border border-gray-200
                         px-2 py-0.5 rounded-md">
              #{{ item._id.slice(-6).toUpperCase() }}
            </span>
    
            <i class="ti ti-chevron-right text-gray-300 text-sm"></i>
          </li>
        </ul>
      </cdk-virtual-scroll-viewport>
    
    </div>
    <div class="bg-white border border-gray-200 rounded-xl overflow-hidden">

      <!-- Header -->
      <div class="flex items-center justify-between px-4 py-3 border-b border-gray-100">
        <div class="flex items-center gap-2">
          <i class="ti ti-building-community text-gray-400 text-base"></i>
          <span class="text-sm font-medium text-gray-800">Micromarkets</span>
        </div>
        <span class="text-xs text-gray-500 bg-gray-50 border border-gray-200 px-3 py-1 rounded-full">
          {{ filtered.length }} micromarkets
        </span>
      </div>
    
      <!-- Search -->
      <div class="flex items-center gap-2 px-4 py-2.5 border-b border-gray-100">
        <i class="ti ti-search text-gray-300 text-sm"></i>
        <input
          type="text"
          [(ngModel)]="searchQuery"
          placeholder="Search micromarket or cluster…"
          class="flex-1 text-sm bg-transparent outline-none text-gray-800 placeholder-gray-300"
        />
      </div>
    
      <!-- Virtual Scroll List -->
      <cdk-virtual-scroll-viewport itemSize="57" class="h-[400px]">
        <ul>
          <li
            *cdkVirtualFor="let item of filtered; let i = index"
            class="flex items-center gap-3 px-4 py-3 cursor-default
                   hover:bg-gray-50 transition-colors duration-150
                   border-b border-gray-100 last:border-b-0
                   animate-[rowIn_0.32s_ease-out_both]"
            [style.animation-delay]="i * 55 + 'ms'"
          >
            <!-- Index badge -->
            <div class="min-w-[26px] h-[26px] rounded-full bg-green-50 flex items-center
                        justify-center text-[11px] font-medium text-green-600
                        animate-[badgePop_0.4s_cubic-bezier(.34,1.56,.64,1)_both]"
                 [style.animation-delay]="i * 55 + 70 + 'ms'">
              {{ i + 1 }}
            </div>
    
            <!-- Name + cluster -->
            <div class="flex-1 min-w-0">
              <p class="text-sm font-medium text-gray-800 truncate">{{ item.micromarketName }}</p>
              <div class="flex items-center gap-1 mt-0.5">
                <i class="ti ti-map-pin text-gray-300 text-[11px]"></i>
                <span class="text-xs text-gray-400">{{ item.cluster }}</span>
              </div>
            </div>
    
            <!-- ID chip -->
            <span class="text-[11px] text-gray-400 font-mono bg-gray-50 border border-gray-200
                         px-2 py-0.5 rounded-md">
              #{{ item._id.slice(-6).toUpperCase() }}
            </span>
    
            <i class="ti ti-chevron-right text-gray-300 text-sm"></i>
          </li>
        </ul>
      </cdk-virtual-scroll-viewport>
    
    </div>
  </div>
</div>
